module.exports = __webpack_public_path__ + "static/media/tabcollapse.cde2f817.svg";